/* GENERATED by scripts/gen-theme.ts from DESIGN.md frontmatter. Do not edit. */
export const palette = {
  "notebook-cream": "#F7F5F2",
  "notebook-margin": "#EFECE8",
  "page-white": "#FFFFFF",
  "hearth-brown": "#1C1A17",
  "lifted-walnut": "#2A2725",
  "espresso-ink": "#332D28",
  "warm-taupe": "#796F67",
  "warm-bone": "#D4CFC9",
  "taupe-on-walnut": "#ACA39A",
  "notebook-edge": "#DDD8D3",
  "inner-walnut": "#3A3633",
  "input-border": "#C9C4BF",
  "instrument-blue": "#0078D4",
  "instrument-blue-dark": "#3B9EE8",
  "instrument-blue-tint": "#0078D419",
  "instrument-blue-dark-tint": "#3B9EE819",
  "vermillion": "#D93025",
  "vermillion-dark": "#F47A81",
  "vermillion-tint": "#D930251A",
  "vermillion-dark-tint": "#F47A811A",
  "workshop-amber": "#C2660A",
  "workshop-amber-dark": "#F29B1D",
  "workshop-amber-tint": "#C2660A1F",
  "workshop-amber-dark-tint": "#F29B1D1F",
  "parsing-amber": "#E8850A",
  "field-green": "#1A7F37",
  "field-green-dark": "#73C881",
  "field-green-tint": "#1A7F3714",
  "field-green-dark-tint": "#73C8811A",
  "input-walnut": "#33302D",
  "disabled-on-walnut": "#8A8078",
  "carplay-indigo": "#7C3AED",
  "card-section-cream": "#64462807",
  "walnut-shadow": "#1A1408"
} as const;
export const scales = {
  "instrument": [
    "#dbecf9",
    "#b6d8f3",
    "#92c5ed",
    "#6db2e6",
    "#499fe0",
    "#248bda",
    "#0078D4",
    "#0d65a9",
    "#1a537e",
    "#264053"
  ],
  "walnut": [
    "#FFFFFF",
    "#F7F5F2",
    "#EFECE8",
    "#DDD8D3",
    "#C9C4BF",
    "#796F67",
    "#332D28",
    "#3A3633",
    "#2A2725",
    "#1C1A17"
  ],
  "success": [
    "#deede2",
    "#bedac6",
    "#9dc8a9",
    "#7cb68d",
    "#5ba470",
    "#3b9154",
    "#1A7F37",
    "#206b33",
    "#275630",
    "#2d422c"
  ],
  "warning": [
    "#f6e9dc",
    "#eed3b9",
    "#e5bd96",
    "#dca873",
    "#d39250",
    "#cb7c2d",
    "#C2660A",
    "#9e5812",
    "#7b4a19",
    "#573b21"
  ],
  "danger": [
    "#fae1e0",
    "#f4c4c1",
    "#efa6a2",
    "#e98982",
    "#e46b63",
    "#de4e44",
    "#D93025",
    "#b02f26",
    "#862f27",
    "#5d2e27"
  ]
} as const;
export const radius = {"sm":"8px","md":"12px","lg":"20px","full":"9999px"} as const;
export const spacing = {"xs":"4px","sm":"8px","md":"12px","lg":"16px","xl":"20px","xxl":"24px"} as const;
export const fontFamily = "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
export const type = {
  "display": {
    "size": "28px",
    "weight": 700,
    "lineHeight": "34px",
    "tracking": "-0.3px"
  },
  "headline": {
    "size": "22px",
    "weight": 600,
    "lineHeight": "28px",
    "tracking": "-0.2px"
  },
  "title": {
    "size": "18px",
    "weight": 600,
    "lineHeight": "24px",
    "tracking": "0px"
  },
  "body": {
    "size": "16px",
    "weight": 400,
    "lineHeight": "24px",
    "tracking": "0px"
  },
  "caption": {
    "size": "12px",
    "weight": 400,
    "lineHeight": "16px",
    "tracking": "0px"
  },
  "label": {
    "size": "14px",
    "weight": 500,
    "lineHeight": "18px",
    "tracking": "0px"
  },
  "eyebrow": {
    "size": "14px",
    "weight": 500,
    "lineHeight": "18px",
    "tracking": "0.6px"
  }
} as const;
